if (!customElements.get('customer-testimonials')) {
    class CustomerTestimonials extends HTMLElement {
        constructor() {
            super();
            this.initSwiper();
        }
        initSwiper() {
            const CustomerTestimonialsSwiper = new Swiper('[data-swiper-id="customer-testimonials"]', {
                slidesPerView: 1,
                spaceBetween: 20,               
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
            }) 
        }
    }

    customElements.define('customer-testimonials', CustomerTestimonials);
}